import { render } from "./PatientPersonal.vue?vue&type=template&id=2c0554f5&scoped=true"
import script from "./PatientPersonal.vue?vue&type=script&lang=js"
export * from "./PatientPersonal.vue?vue&type=script&lang=js"

import "./PatientPersonal.vue?vue&type=style&index=0&id=2c0554f5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0554f5"]])

export default __exports__